<template>
	<div style="@media screen {max-width: 70%; } @media  (max-width: 767px) { min-width: 100%;}">
		<br />
		<div style="width: 100%;">
			<transition name="stock-management-transition">
				<SiteDetails :site="getSelectedSite()" v-if="siteSelected != null" @toggle-content="siteDetailsClosed()"></SiteDetails>
			</transition>
		</div>
		<div id="stock-management" v-if="siteSelected === null">
			<div v-b-toggle.collapse-1 @click="expandCollapse_1()" class="toggle-header">
				<!-- label -->
				<h3>Stock Management By Site<!-- chevron --><i v-bind:class="[section_1_expanded ? 'fa-solid fa-chevron-up chevrons' : 'fa-solid fa-chevron-down chevrons']"></i></h3>
			</div>
			<b-collapse id="collapse-1" visible class="moc_sub_section">
				<div class="clickable-tile" v-for="(site, index) in sites" :key="index"
					@click="siteClicked(site.title)">
					<!-- <span v-if="action_items" class="badge">{{action_items}}</span> -->
					<div class="tile-front">
						<div class="icon"><i :class="'fa-solid fa-' + site.icon" style="padding-right: 10px"></i></div>
						<p>{{ site.type }}</p>
					</div>
					<div class="tile-back">
						<p>{{ site.title }} {{ site.type }}</p>
					</div>
					<div class="tile-footer">
						<p>{{ site.title }}</p>
					</div>
				</div>

			</b-collapse>
			<br />

			<div v-b-toggle.collapse-2 @click="expandCollapse_2()" class="toggle-header">
				<!-- label -->
				<h3>Stock Management By Type <i v-bind:class="[section_2_expanded ? 'fa-solid fa-chevron-up chevrons' : 'fa-solid fa-chevron-down chevrons']"></i></h3>
			</div>
			<b-collapse id="collapse-2" visible class="moc_sub_section">

				<h4>BroodStock</h4>
				<div class="clickable-tile disabled">
					<div class="tile-front">
						<div class="icon"><i class="fa-solid fa-dna"></i></div>
						<p>Genetics</p>
					</div>
					<div class="tile-back">
						<p>Genetics and Breeding Tracking</p>
					</div>
					<div class="tile-footer disabled">
						<p>Genetics</p>
					</div>
				</div>
				<div class="clickable-tile disabled">
					<div class="tile-front">
						<div class="icon"><i class="fa-solid fa-shuffle"></i></div>
						<p>Neo Males</p>
					</div>
					<div class="tile-back">
						<p>Breeding and Tracking of Neo Males</p>
					</div>
					<div class="tile-footer disabled">
						<p>Neo Males</p>
					</div>
				</div>
				<div class="clickable-tile disabled">
					<div class="tile-front">
						<div class="icon"><i class="fa-solid fa-triangle-exclamation"></i></div>
						<p>Mortality Rates</p>
					</div>
					<div class="tile-back">
						<p>Tracking Mortality Rates</p>
					</div>
					<div class="tile-footer disabled">
						<p>Mortality Rates</p>
					</div>
				</div>

				<hr />
				<div class="flex-container">
					<h4 style="padding-bottom: 10px; top: 0;">Production Stock</h4>
					<div class="production-stock-summary">
						<div class="production-stock-summary-item"><i class="fa-solid fa-fish-fins"></i> 15M</div>
						<div class="production-stock-summary-header">COUNT</div>
					</div>
					<div class="production-stock-summary">
						<div class="production-stock-summary-item"><i class="fa-solid fa-triangle-exclamation"></i> 15%
						</div>
						<div class="production-stock-summary-header">MORTALITY RATES</div>
					</div>
					<div class="production-stock-summary">
						<div class="production-stock-summary-item">289 days</div>
						<div class="production-stock-summary-header">TIME AT SEA</div>
					</div>
					<div class="production-stock-summary">
						<div class="production-stock-summary-item"><i class="fa-solid fa-chart-line"></i> +1.4%</div>
						<div class="production-stock-summary-header">GROWTH RATE ANALYSIS</div>
					</div>
				</div>
				<hr />
				<div class="flex-container">
					<h4 style="padding-bottom: 10px; top: 0;">Fish Health</h4>
					<div class="production-stock-summary">
						<div class="production-stock-summary-item"><i class="fa-solid fa-virus-slash"></i> Active</div>
						<div class="production-stock-summary-header">DISEASE MANAGEMENT</div>
					</div>
					<div class="production-stock-summary">
						<div class="production-stock-summary-item"><i class="fa-solid fa-bugs"></i> Active</div>
						<div class="production-stock-summary-header">LICE MANAGEMENT</div>
					</div>
					<div class="production-stock-summary">
						<div class="production-stock-summary-item"><i class="fa-solid fa-chart-line"></i> 1.5%</div>
						<div class="production-stock-summary-header">FISH ESCAPES</div>
					</div>
				</div>
			</b-collapse>
		</div>
	</div>
</template>

<script>
import SiteDetails from "./SiteDetails.vue";

export default {
	name: "AquacultureData",
	components: {
		SiteDetails,
	},
	data: function () {
		return {
			siteSelected: null,
			sites: [],

			/* Expand and Collapse */
			section_1_expanded: true,
			section_2_expanded: true,
		};
	},
	props: {},

	mounted: function () {
		console.log("Mounted Stock management page")
		this.sites = this.$parent.$parent.sites;

		console.log("Sites from parent: ", this.sites);
	},
	methods: {
		siteClicked(index) {
			this.siteSelected = index;
		},
		siteDetailsClosed() {
			console.log("Caught site closed...");
			this.siteSelected = null;
		},
		getSelectedSite() {
			return this.sites.find((site) => site.title === this.siteSelected);
		},
		expandCollapse_1() {
			if (this.section_1_expanded) {
				this.section_1_expanded = false;
			} else {
				this.section_1_expanded = true;
			}
		},
		expandCollapse_2() {
			if (this.section_2_expanded) {
				this.section_2_expanded = false;
			} else {
				this.section_2_expanded = true;
			}
		},

	}
};
</script>

<style scoped>
@media screen {
	.clickable-tile {
		box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
		text-align: center;
		padding-top: 10px;
		border: 1px solid #ccc;
		cursor: pointer;
		margin: 15px;
		/* Half of the desired spacing (30px / 2) */
		width: calc(33.3% - 30px);
		/* 3 columns with 30px spacing */
		max-width: 180px;
		min-width: 180px;
		min-height: 100px;
		display: inline-block;
		position: relative;
		perspective: 1000px;
		/* Depth of the 3D space for the flip effect */
	}
}

@media (max-width: 767px) {
	.clickable-tile {
		box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
		text-align: center;
		padding-top: 15px;
		border: 1px solid #ccc;
		cursor: pointer;
		margin: 7.5px;
		/* Half of the desired spacing (30px / 2) */
		min-width: calc(50% - 15px);
		/* 2 columns with 30px spacing */
		min-height: 100px;
		display: inline-block;
		position: relative;
		perspective: 1000px;
		/* Depth of the 3D space for the flip effect */
	}
}

/* Transition for the tile content */
.stock-management-transition-enter-active {
	transition: transform 0.25s ease-in-out;
}

.stock-management-transition-leave-active {
	transition: transform 0.1s ease-in-out;
}

.stock-management-transition-enter,
.stock-management-transition-leave-to {
	transform: scale(0);
}

.stock-management-transition-enter-to,
.stock-management-transition-leave {
	transform: scale(1);
}

/* End Transitions */

.icon {
	font-size: 2rem;
	/* Adjust the size of the icon as needed */
	margin-bottom: 10px;
	/* Add spacing between the icon and text */
}

.tile-front,
.tile-back,
.tile-footer {
	width: 100%;
	position: absolute;
	transition: transform 0.5s;
	backface-visibility: hidden;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.tile-back {
	text-wrap: pretty;
}

.tile-footer {
	height: 25%;
}

.tile-footer {
	bottom: 0;
	/* Position the footer at the bottom */
	background-color: #d9d9d9;
	/* Add a background color to the footer */
	color: #000000;
	/* Set the text color of the footer */
	padding: 5px;
	/* Adjust the padding as needed */
	padding-top: 10%;
	font-weight: bold;
}

.tile-front {
	transform: rotateY(0deg);
}

.tile-back {
	transform: rotateY(180deg);
}

.clickable-tile:hover .tile-front {
	transform: rotateY(180deg);
}

.clickable-tile:hover .tile-back {
	transform: rotateY(0deg);
}

.chevrons {
	float: right;
}

.toggle-header {
	border-bottom: 1px solid #000000;

}

[id^="site-modal"]>.modal-dialog {
	max-width: 95% !important;
	min-width: 95% !important;
}

.flex-container {
	justify-content: space-evenly;
}

/* .production-stock-summary { min-width: 150px; } */
.production-stock-summary-header {
	margin-top: -7px;
	margin-bottom: 5px;
	color: grey;
}

.production-stock-summary-item {
	font-size: 39px;
	color: #6c757d;
	font-weight: 200;
}

/* Deal with the 'disabled' look */
.disabled {
	color: grey !important;
	cursor: default !important;
}

@media (max-width: 767px) {

	/* .flex-container { display: block; } */
	.flex-container {
		justify-content: left;
		display: table;
	}

	.tile-content-wrapper {
		max-width: 80%;
	}

	/* Display the site summary items in a block */
	.production-stock-summary {
		display: inline;
	}

	hr {
		display: none;
	}
}
</style>
